export default {
    制造实力:'制造实力',
    产品展示:'产品展示',
    工厂分布:'工厂分布',
    车身金属:'车身金属',
    //index
    productList:['模内转印饰条\n嵌件注塑饰条\n真木饰条\n氛围灯透光饰条','仪表板\n中央通道\n内顶棚\n门板\nABC立柱\n头枕\n风管\n格栅\n扰流板\n加油/电口盖\n包边玻璃\n落水槽','白车身件\n底盘金属件\n焊接总成件\n排气系统','后视镜系统\n电子控制单元\n线束保护系统\n电池包业务'],
    productPisitionList:[['真铝'],['保险杠'],['防撞梁'],['后视镜']],
    客户:'客户',
    优势:'优势',
    产品:'产品'
}
